import { CardMedia, SxProps } from "@mui/material";
import { Theme } from "@mui/system";
import { animated, useSpring } from "react-spring";

const AnimatedCar = ({ options, image, sx }: { options: any, image: string, sx?: SxProps<Theme> }) => {
  const [styles] = useSpring(() => options, []);
  const Animated = animated((props) => {
    return (
      <CardMedia {...props} component="img" image={image} sx={{ position: "absolute", ...sx }} />
    );
  });

  return (
    <Animated style={styles} />
  );
};

export default AnimatedCar;